import {makeObservable, observable, action} from 'mobx';

/**
 * ViewStateStore - 管理任务运行页面的视图状态
 *
 * 职责:
 * - 管理进程/IDE 视图切换 (processActivTab)
 * - 管理 Hero-Agent 交互状态 (hasNewSolution, heroInputValue)
 * - 管理阶段信息展示状态 (stageInfoName)
 * - 管理岛屿列表展示模式 (islandFull)
 *
 * 设计原则:
 * - 单一职责: 只管理 UI 视图状态
 * - 无业务逻辑: 不处理任务执行逻辑
 * - 状态独立: 与任务执行状态解耦
 */
export class ViewStateStore {
    /** 当前激活的 Tab: '1' = 进程, '2' = IDE */
    processActivTab: string = '1';

    /** Hero-Agent 是否有新的初始解 */
    hasNewSolution: boolean = false;

    /** Hero-Agent 交互输入框的值 */
    heroInputValue: string = '';

    /** Tab 当前选中的任务阶段名称 */
    stageInfoName: 'COLDSTART' | 'EVOLVE' | 'REPORT' | 'SELECT' | '' = '';

    /** 岛屿列表是否全量展示 */
    islandFull: boolean = false;

    constructor() {
        makeObservable(this, {
            processActivTab: observable,
            hasNewSolution: observable,
            heroInputValue: observable,
            stageInfoName: observable,
            islandFull: observable,
            setProcessActivTab: action.bound,
            setHasNewSolution: action.bound,
            setHeroInputValue: action.bound,
            setStageInfoName: action.bound,
            setIslandFull: action.bound,
            reset: action.bound
        });
    }

    /** 设置当前激活的 Tab */
    setProcessActivTab(tab: string) {
        this.processActivTab = tab;
    }

    /** 设置 Hero-Agent 是否有新解 */
    setHasNewSolution(hasNew: boolean) {
        this.hasNewSolution = hasNew;
    }

    /** 设置 Hero-Agent 输入框的值 */
    setHeroInputValue(value: string) {
        this.heroInputValue = value;
    }

    /** 设置当前选中的任务阶段名称 */
    setStageInfoName(name: 'COLDSTART' | 'EVOLVE' | 'REPORT' | 'SELECT' | '') {
        this.stageInfoName = name;
    }

    /** 设置岛屿列表是否全量展示 */
    setIslandFull(isFull: boolean) {
        this.islandFull = isFull;
    }

    /** 重置所有视图状态 */
    reset() {
        this.processActivTab = '1';
        this.hasNewSolution = false;
        this.heroInputValue = '';
        this.stageInfoName = '';
        this.islandFull = false;
    }
}
